import { Field, ID, Int, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class SaveRouteArgs extends ActionArgs {
  @Field(() => ID, { nullable: true })
  _id?: string

  @Field(() => String, { nullable: true })
  code?: string

  @Field(() => String, { nullable: true })
  remarks?: string

  @Field(() => String, { nullable: true })
  status?: string

  @Field(() => Int, { nullable: true })
  distance?: number

  @Field(() => [String], { nullable: true })
  tags?: string[]
}
